import React from 'react';
const testimonials = [{
  initials: 'MF',
  name: 'María F.',
  location: 'Buenos Aires · Lashista',
  quote: 'En la primera semana apliqué el sistema de seña y se me cortaron las cancelaciones de raíz. Antes perdía 3 o 4 turnos por semana. Ahora en un mes tuve UNO solo y lo cubrí en 15 minutos con el bono de rescate.'
}, {
  initials: 'VL',
  name: 'Valentina L.',
  location: 'Córdoba · Lashista',
  quote: 'Los mensajes del Bono 2 me cambiaron la vida. Antes me quedaba en blanco cuando una clienta cancelaba tarde. Ahora copio, pego y listo. Sin culpa, sin drama, sin perder plata.'
}, {
  initials: 'SR',
  name: 'Sofía R.',
  location: 'Rosario · Lashista',
  quote: 'El Checklist de Clienta de Riesgo me salvó de dos cancelaciones en la misma semana. Vi las señales, apliqué el protocolo rojo y evité dos huecos que antes me hubieran arruinado el jueves.'
}];
const painPoints = ['Abrís WhatsApp y hay un mensaje que dice "che no puedo ir hoy" a las 9 de la mañana cuando el turno es a las 10', 'Pusiste políticas pero cuando llegó el momento de aplicarlas no supiste qué decir y cediste igual por no generar conflicto', 'Tenés huecos en la agenda todas las semanas y no tenés idea de cómo cubrirlos rápido sin desesperarte ni bajar el precio', 'Hay clientas que "siempre tienen algo" y vos seguís atendiéndolas porque no sabés cómo filtrarlas desde el principio', 'Sabés que tenés que cobrar seña pero cuando llega el momento te da vergüenza pedirla y terminás sin cobrarla', 'Al final del mes trabajaste mucho pero los números no cierran porque los turnos caídos se comieron la ganancia', 'Tu espalda, tu cuello y tus ojos están pagando el precio de una agenda mal organizada y un cuerpo sin protocolo de protección'];
export function ProblemSection() {
  return <section className="py-16 md:py-24 bg-[#F4EDE4]" data-id="element-134">
      <div className="max-w-6xl mx-auto px-4" data-id="element-135">
        {/* Section eyebrow */}
        <div className="text-center mb-12 md:mb-14" data-id="element-136">
          <div className="text-[10px] tracking-[0.3em] text-[#B8956A] font-bold uppercase mb-3" data-id="element-137">
            ⭐ Lo que dicen las que ya lo tienen
          </div>
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-5 md:gap-6 mb-20 md:mb-28" data-id="element-138">
          {testimonials.map((t, i) => <div key={i} className="bg-white border border-[#E8D5C4] rounded-2xl p-6 hover:border-[#B8956A] transition-colors shadow-sm" data-id="element-139">
              <div className="flex items-center gap-3 mb-4" data-id="element-140">
                <div className="w-11 h-11 rounded-full bg-[#FAF6F0] text-[#5A2A3D] flex items-center justify-center font-bold text-sm border border-[#E8D5C4]" data-id="element-141">
                  {t.initials}
                </div>
                <div data-id="element-142">
                  <div className="text-[#B8956A] text-xs tracking-wider mb-0.5" data-id="element-143">
                    ★★★★★
                  </div>
                  <div className="text-sm text-[#2D1A22] font-medium" data-id="element-144">
                    {t.name}
                  </div>
                </div>
              </div>
              <p className="text-[#5A4A4F] italic leading-relaxed text-sm md:text-base" data-id="element-145">
                "{t.quote}"
              </p>
              <div className="mt-4 text-xs text-[#B8956A] font-medium tracking-wider uppercase" data-id="element-146">
                {t.location}
              </div>
            </div>)}
        </div>

        {/* Pain Points */}
        <div className="max-w-3xl mx-auto text-center mb-10 md:mb-12" data-id="element-147">
          <h2 className="text-3xl md:text-5xl text-[#2D1A22] mb-6 leading-tight" data-id="element-148">
            ¿Cuántos lunes más vas a seguir mirando{' '}
            <span className="italic" data-id="element-149">el hueco en tu agenda</span>?
          </h2>
          <p className="text-base md:text-lg text-[#5A4A4F] leading-relaxed" data-id="element-150">
            Querés tener el negocio que te merecés. Tenés la técnica. Pero nadie
            te dijo que ibas a pasar los domingos con el estómago apretado
            esperando si la clienta del lunes confirma o no, los martes con un
            turno vacío que podrías haber llenado y los viernes contando cuánta
            plata perdiste esa semana por culpa de alguien que no apareció.
          </p>
          <p className="text-lg md:text-xl text-[#5A2A3D] italic font-medium mt-6" data-id="element-151">
            No es falta de clientas. Es falta de un sistema.
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-white border border-[#E8D5C4] rounded-2xl md:rounded-3xl p-6 md:p-10 shadow-md" data-id="element-152">
          <div className="space-y-5" data-id="element-153">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-3 md:gap-4" data-id="element-154">
                <span className="text-[#5A2A3D] text-lg mt-0.5 shrink-0" data-id="element-155">
                  ❌
                </span>
                <p className="text-sm md:text-base text-[#5A4A4F] leading-relaxed" data-id="element-156">
                  {point}
                </p>
              </div>)}
          </div>
        </div>

        <div className="text-center mt-12 md:mt-16" data-id="element-157">
          <h3 className="text-2xl md:text-4xl text-[#2D1A22]" data-id="element-158">
            ¿Y si este fuera el último lunes que{' '}
            <span className="italic text-[#5A2A3D]" data-id="element-159">
              perdés un turno sin sistema
            </span>
            ?
          </h3>
        </div>
      </div>
    </section>;
}